import React from 'react'
import dayjs from 'dayjs'

import { FilterContainer, RangePicker } from '@lmc/ui-kit'

type MedStockDateFilterProps = {
  endDate: any
  startDate: any
  testId?: string
}

/**
@description Handles date change

@param {array} dates. Array that contains the start date and end date. If the filter has been cleared,
dates will equal [], so we set the end date and start date to be 2 weeks ago and today. 

@param {function} setEndDate. Sets the end date
@param {function} setStartDate. Sets the start date

@param {object} todayDate. The current date. Not hard coded to allow it to be passed in for testing

@returns {function} handleDateChange.
*/

const handleDateChange = (props: any) => {
  const { dates, setEndDate, setStartDate, todayDate } = props

  if (!dates) {
    setStartDate(dayjs(todayDate).subtract(14, 'days'))
    setEndDate(dayjs(todayDate))
  } else {
    setStartDate(dates[0])
    setEndDate(dates[1])
  }
}

export default function MedStockDateFilter(props: MedStockDateFilterProps) {
  const { endDate, startDate, testId } = props

  return (
    <div
      style={styles.container}
      data-testid={
        testId ? `${testId}-med-stock-date-filter` : 'med-stock-date-filter'
      }
    >
      <FilterContainer
        title=""
        data-testid={testId ? `${testId}-filter-container` : 'filter-container'}
      >
        <RangePicker
          defaultValue={[startDate, endDate]}
          onChange={(dates) => {
            handleDateChange({ ...props, dates })
          }}
          data-testid={
            testId ? `${testId}-date-range-picker` : 'date-range-picker'
          }
        />
      </FilterContainer>
    </div>
  )
}

MedStockDateFilter.propTypes = {}

const styles = {
  container: {
    padding: '16px 0px'
  }
}
